import React, { useState } from "react";
import "./style.css";
import OtpInput from "react-otp-input";
import Modal from "react-bootstrap/Modal";

const OTPModal = (props) => {
  const { onVerfy, onChange, value, handleResend, disabled, timer } = props;

  return (
    <Modal show={true}>
      <div className="otpmodal-container">
        <div className="otpmodal_view">
          <h3>Enter OTP</h3>
          <OtpInput
            value={value}
            onChange={onChange}
            numInputs={4}
            renderSeparator={<span>-</span>}
            renderInput={(props) => <input {...props} />}
            inputStyle="otp-input"
          />
          <button
            onClick={handleResend}
            style={{ backgroundColor: 'transparent', border: 'none', textDecoration: 'underline', color: '#294859', marginTop: 10, fontWeight: '500' }}>
            Resend OTP 
          </button>
          <button className="otpbtn" onClick={onVerfy}>
            Verify
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default OTPModal;
